import { type LoginInfo } from '~/types';
import { useProfileLoginStore } from '~/store/profileLogin';
import { extractLoginInfoFromLocalStorage } from '~/composables/useProfileLogin';

export default defineNuxtPlugin((nuxt) => {
  nuxt.hook('app:beforeMount', () => {
    const profileLoginStore = useProfileLoginStore();
    const getUserSubscriptionProducts = (): any[] => {
      try {
        const runtimeConfig = useRuntimeConfig().public;
        const storageKey = runtimeConfig.subscribedDataLocalStorageKey;
        const storageValue = localStorage.getItem(storageKey);
        if (!storageValue) {
          return [];
        }
        const userData = JSON.parse(storageValue);
        return userData.value.products || [];
      } catch (e) {
        throw createError('Could not figure out subscription products');
      }
    };

    const getLoginStatus = () => {
      const runtimeConfig = useRuntimeConfig().public;
      const storageKey = runtimeConfig.subscribedDataLocalStorageKey;
      const loginInfo = extractLoginInfoFromLocalStorage(storageKey);
      const products = getUserSubscriptionProducts();
      const isSubscriber = products.length > 0;
      if (Object.keys(loginInfo).length === 0) {
        profileLoginStore.setLoginStatus({
          isLoggedIn: false,
          username: (loginInfo as LoginInfo).username || '',
          firstName: (loginInfo as LoginInfo).firstName || '',
          lastName: (loginInfo as LoginInfo).lastName || '',
          ncpIdHash: (loginInfo as LoginInfo).ncpIdHash || '',
          brazeId: (loginInfo as LoginInfo).brazeId || '',
          oneId: '',
          products,
          isSubscriber,
          isTotalSubscriber: false
        });
        return;
      }

      profileLoginStore.setLoginStatus({
        isLoggedIn: true,
        username: (loginInfo as LoginInfo).username || '',
        firstName: (loginInfo as LoginInfo).firstName || '',
        lastName: (loginInfo as LoginInfo).lastName || '',
        ncpIdHash: (loginInfo as LoginInfo).ncpIdHash || '',
        brazeId: (loginInfo as LoginInfo).brazeId || '',
        oneId: (loginInfo as LoginInfo).oneId || '',
        products,
        isSubscriber,
        isTotalSubscriber: !!((loginInfo as LoginInfo).hasTotal)
      });
    };

    getLoginStatus();
  });
});
